import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { getIdTokenPromise } from '../utils/tokenHelper';
import { v4 as uuidv4 } from 'uuid';
import { handleFailToast } from '../utils/errorHandler';
import { t } from 'i18next';

const applyRequestInterceptor = (
  instance: AxiosInstance,
  config: AxiosRequestConfig,
  auth: any,
  cookieDomain: string
) => {
  instance.interceptors.request.use(
    async (reqConfig) => {
      const isCustomLogin = localStorage.getItem('isCustomLogin') === 'true';

      if (!isCustomLogin) {
        return { ...reqConfig, ...config, useToken: false };
      }

      if (config.useLoading) {
        // setLoading(true);
      }
      if (config.useToken) {
        const idToken = await getIdTokenPromise({ auth, axiosInstance: instance, cookieDomain });

        reqConfig.headers = {
          ...reqConfig.headers,
          Authorization: `Bearer ${idToken}`,
          'X-Bubbletap-Context': uuidv4(),
          'X-Bubbletap-Device': auth?.currentUser?.uid ?? '',
        };
      }

      return reqConfig;
    },
    (error) => {
      // handleFailToast(t(GENERAL_ERROR_MESSAGE));
      handleFailToast('error');
    }
  );
};

export { applyRequestInterceptor };
